import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { baseURL, SERVICES } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";

function ServicesSectionWeb() {
  const [services, setServices] = useState([]);
  const { i18n } = useTranslation(); // Get the current language

  useEffect(() => {
    Axios.get(`${baseURL}/${SERVICES}/view`)
      .then((response) => setServices(response.data))
      .catch((error) => console.error("Error fetching services:", error));
  }, []);

  const servicesdata = services.map((service) => {
    return (
      <div className="col-lg-4 col-md-6" key={service.id}>
        <div className="service-item position-relative">
          <div className="icon">
            <Image src={service.image.path} style={{ width: "50px" }} />
          </div>
          <Link to="#" className="stretched-link">
            <h3 className="text-white">
              {i18n.language === "ar" ? service.title_ar : service.title_en}
            </h3>
          </Link>
          <p className="text-white">
            {i18n.language === "ar" ? service.desc_ar : service.desc_en}
          </p>
        </div>
      </div>
    );
  });

  return (
    <>
      {/* Services Section */}
      <section id="services" className="services section">
        <div className="container">
          <div className="row gy-4">{servicesdata}</div>
        </div>
      </section>
      {/* /Services Section */}
    </>
  );
}

export default ServicesSectionWeb;
